import type { ReactElement } from "react"
import { useCallback } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import _t from "@core/i18n"
import { createDomainSearchrModalHideAction } from "~/store/domain-search/actions"
import { useAppDispatch, useAppSelector } from "~/store/hooks"
import type { AppState } from "~/store/reducer"
import DomainInputField from "../DomainInputField"
import ModalTemplateWrapper from "../ModalTemplateWrapper"

export default function DomainSearchModal(): ReactElement {
  const dispatch = useAppDispatch()
  const searchModal = useAppSelector(
    (state: AppState) => state.domainSearch.searchModal
  )

  const handleClose = useCallback((): void => {
    dispatch(createDomainSearchrModalHideAction())
  }, [dispatch])

  return (
    <ModalTemplateWrapper
      isOpen={searchModal.visible}
      onCloseButtonClick={handleClose}
      content={
        <>
          <TextAtm align="center" pushSpace={2} typography="huge">
            {searchModal.title}
          </TextAtm>

          <DomainInputField
            extension={searchModal.extension}
            placeholderText={_t("domainSearch.inputPlaceholder")}
            afterSubmit={() => {
              handleClose()
            }}
          />
        </>
      }
    />
  )
}
